import { Controller } from 'stimulus'
import { action_fetch_getHTML } from 'shared/js/fetch'

export default class extends Controller {

    async refresh(ev){
        this.fetchAction(ev.target.getAttribute("data-url"), ev.target.getAttribute("data-show"))
    }

    fetchAction(url, action_show){
        return action_fetch_getHTML(url, action_show)
    }
}